import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";

import { registerNavSection } from "./shell/navigation";

registerNavSection({ key: "projects", spoke: "projects", title: "Projects", icon: AccountTreeOutlinedIcon, order: 58, entries: [
  { label: "Portfolio", to: "/app/projects", permission: "projects.project.view" },
] });
